import { render, staticRenderFns } from "./segmentosConfiguracoesEditar.vue?vue&type=template&id=db4f8a9e&scoped=true&"
import script from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
export * from "./segmentosConfiguracoesEditar.vue?vue&type=script&lang=js&"
import style0 from "./segmentosConfiguracoesEditar.vue?vue&type=style&index=0&id=db4f8a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4f8a9e",
  null
  
)

export default component.exports